import { useEffect, useRef } from 'react';
import { useRouter } from 'next/router';

export default function useAuthValidation() {
  const router = useRouter();
  const validating = useRef(false);

  useEffect(() => {
    const validate = async () => {
      if (router.pathname === '/login') return;

      const token = localStorage.getItem('auth_token');
      if (!token) {
        router.replace('/login');
        return;
      }

      if (validating.current) return;
      validating.current = true;

      try {
        const res = await fetch('/api/auth/validate', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (!res.ok) {
          logout();
        }
      } finally {
        validating.current = false;
      }
    };

    validate();
  }, [router.pathname]);
}

function logout() {
  localStorage.removeItem('auth_token');
  document.cookie = 'auth_token=; Max-Age=0; path=/';
  window.location.href = '/login';
}
